import {Component, OnInit} from '@angular/core';
import {OrganisationCustomerService} from '@services/customers/organisation-customer.service';
import {MessengerService} from '@services/messenger/messenger.service';
import { Models } from '@ibexfusion/models';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'app-my-organization',
    templateUrl: './my-organization.component.html',
    styleUrls: ['./my-organization.component.scss'],
    providers: [OrganisationCustomerService],
    standalone: false
})

export class MyOrganizationComponent implements OnInit {

  organization: Models.MyOrganisation;
  organizationData;
  public form = new UntypedFormGroup({
    organisationName: new UntypedFormControl({value: '', disabled: true}),
    priceModel: new UntypedFormControl({value: '', disabled: true}),
    address: new UntypedFormGroup({
      city: new UntypedFormControl({value: '', disabled: true}),
      countryCode: new UntypedFormControl({value: '', disabled: true}),
      street: new UntypedFormControl({value: '', disabled: true}),
      streetAdditional: new UntypedFormControl({value: '', disabled: true}),
      zip: new UntypedFormControl({value: '', disabled: true}),
    }),
    contact: new UntypedFormGroup({
      fax: new UntypedFormControl({value: '', disabled: true}),
      mail: new UntypedFormControl({value: '', disabled: true}),
      tel: new UntypedFormControl({value: '', disabled: true}),
      url: new UntypedFormControl({value: '', disabled: true}),
    }),
    name: new UntypedFormGroup({
      firstName: new UntypedFormControl({value: '', disabled: true}),
      lastName: new UntypedFormControl({value: '', disabled: true}),
      title: new UntypedFormControl({value: '', disabled: true}),
    }),
    comment: new UntypedFormControl({value: '', disabled: true})
  });
  constructor( public organisationCustomerService: OrganisationCustomerService, private ms: MessengerService) {

  }

  ngOnInit() {
    this.organization = this.ms.getOrganisation();
    if (this.organization) {
      this.organisationCustomerService.get(this.organization.organisationCustomerId).then(result => {
        this.organizationData = result;
        this.form.patchValue(this.organizationData);
      });
    }
  }
}
